import React from "react";
import {getCurrentYear} from "../../../Framework/Constants/DateHelpers";

const UserPageFooter = () => {
    return (
        <div className={'faded text-center mt-xxxl pb-md'}>
            <small>© Copyright 2008-{getCurrentYear()} UK Postbox - All Rights Reserved</small>
        </div>
    )
}

export default UserPageFooter